import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function CustomerReviews({
  reviews = [],
  title = "",
  subtitle = ""
}) {
  const [active, setActive] = useState(0);
useEffect(() => {
  if (!reviews.length) return;

  const interval = setInterval(() => {
    setActive((prev) => (prev + 1) % reviews.length);
  }, 3000);

  return () => clearInterval(interval);
}, [reviews.length]);

  return (
    <>
      {/* Desktop */}
      <section className="w-full max-w-7xl mx-auto hidden md:block py-4 md:py-8 px-4">
        <div className="flex flex-col gap-3 mb-10 mt-10 items-center text-center">
          <h2 className="h2-mb h2-md h2-lg h2-2xl">
            <span className="text-[#0b2b40]">{title}</span>
          </h2>
          <p className="text-gray-500 text-sm md:text-lg w-11/12 md:w-1/3 mt-4 text-center">
            {subtitle}
          </p>
        </div>

        {/* Cards row */}
      <div className="mt-14 flex gap-6 justify-center">
  {reviews.map((review, index) => (
    <motion.div
      key={index}
      layout
      onClick={() => setActive(index)}
      transition={{ duration: 0.45, ease: "easeInOut" }}
      className={`
        relative cursor-pointer rounded-2xl overflow-hidden 
        bg-white shadow-lg flex items-stretch h-[300px]
        ${active === index ? "w-[550px]" : "w-[180px]"}
      `}
    >
      <img
        src={review.image}
        alt={review.name}
        className="h-full w-[180px] object-cover"
      />

      <AnimatePresence mode="wait">
        {active === index && (
          <motion.div
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -40, opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="p-6 flex flex-col justify-between w-full bg-[#0b2b40] text-white"
          >
            <p className="text-md leading-relaxed">{review.text}</p>
            <div>
              <h4 className="text-lg font-semibold">{review.name}</h4>
              <p className="text-white/80 text-sm">{review.role}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  ))}
</div>

      </section>

      {/* Mobile */}
      <section className="w-full max-w-7xl block md:hidden mx-auto py-4 md:py-8 px-4">
        <div className="flex flex-col gap-3 mb-10 mt-10 items-center text-center">
          <h2 className="text-3xl md:text-5xl font-semibold">
            <span className="text-[#0b2b40]">{title}</span>
          </h2>
          <p className="text-gray-500 text-sm md:text-lg w-11/12 md:w-1/3 mt-4">
            {subtitle}
          </p>
        </div>

        <div className="mt-14 flex flex-col md:flex-row gap-6 justify-center items-center md:items-stretch">
          {reviews.map((review, index) => (
            <div
              key={index}
              onClick={() => setActive(index)}
              className={`
                cursor-pointer rounded-2xl overflow-hidden bg-white shadow-lg 
                transition-[width] duration-500 flex
                md:flex-row flex-col
                ${active === index ? "md:w-[550px] w-full" : "md:w-[180px] w-full"}
              `}
            >
              <img
                src={review.image}
                alt={review.name}
                className="object-cover md:h-[250px] md:w-[180px] w-full h-[250px]"
              />

              {active === index && (
                <div className="p-6 flex flex-col gap-4 w-full bg-[#0b2b40] text-white">
                  <p className="text-md leading-relaxed">{review.text}</p>
                  <div>
                    <h4 className="text-lg font-semibold">{review.name}</h4>
                    <p className="text-white/80 text-sm">{review.role}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
